import React, { useState, useEffect } from 'react'
import { Sun, Moon, Menu } from 'lucide-react'

const Nav: React.FC = () => {
  const [theme, setTheme] = useState<'light' | 'dark'>('light')
  const [hasScrolled, setHasScrolled] = useState(false)

  // Initialize theme from localStorage
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') as 'light' | 'dark' | null
    const initialTheme = savedTheme || 'light'
    setTheme(initialTheme)
    document.documentElement.setAttribute('data-theme', initialTheme)
  }, [])

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setHasScrolled(window.scrollY > 100)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  // Toggle theme
  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark'
    setTheme(newTheme)
    document.documentElement.setAttribute('data-theme', newTheme)
    localStorage.setItem('theme', newTheme)
  }

  return (
    <nav 
      className={`px-6 py-1 backdrop-blur-md border-b sticky top-0 z-50 ${
        hasScrolled ? 'bg-primary/[0.98]' : ''
      }`}
      style={{ 
        backgroundColor: hasScrolled ? undefined : '#20293a', 
        borderBottomColor: '#4b5266' 
      }}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center">
          <img 
            src="/images/code-beacon-color.svg" 
            alt="Code Beacon" 
            width="160" 
            height="40" 
          />
        </div>
        
        <div className="hidden md:flex items-center space-x-8">
          <a href="#services" className="nav-link">Services</a>
          <a href="#about" className="nav-link">About</a>
          <a href="#insights" className="nav-link">Insights</a>
          <button 
            id="theme-toggle"
            className="theme-toggle relative"
            style={{ width: '40px', height: '40px' }}
            title="Toggle dark/light mode"
            onClick={toggleTheme}
          >
            <Sun 
              className={`light-icon ${theme === 'dark' ? 'hidden' : ''}`}
              style={{ width: '20px', height: '20px' }}
            />
            <Moon 
              className={`dark-icon ${theme === 'light' ? 'hidden' : ''}`}
              style={{ width: '20px', height: '20px' }}
            />
          </button>
          <a href="mailto:hello@code-beacon.io" className="btn-primary nav-cta-button">Talk to Us</a>
        </div>
        
        <button className="md:hidden text-white">
          <Menu className="w-6 h-6" />
        </button>
      </div>
    </nav>
  )
}

export default Nav